export default {
  version: state => {
    if (state.info.versionMajor && state.info.versionMinor) {
      return `${state.info.versionMajor}.${state.info.versionMinor}.${state.info.versionBuild}`;
    } else {
      return 'N/A';
    }
  },
}

